import { map } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { RentalObjectCategory } from '../../model/const/enums';
import { VacantRentalObjectService } from './../data/vacant-period.service';
import { rentalObjectFormCommand } from '../../model/const/command';
import { MessageService } from '../../../core/service/message.service';

@Injectable()
export class CreateContractRentalObjectCommandHandler implements ICommandHandler {
  constructor(
    private _messageDispather: ComponentMessageDispatcher,
    private _navigation: NavigationService,
    private _messageService: MessageService,
    private _service: VacantRentalObjectService,
    @Inject('category') category: RentalObjectCategory
  ) {
    this._path = this._getPath(category);
  }

  private readonly _path: string[];

  private _getPath(category: RentalObjectCategory) {
    let segment = '';
    switch (category) {
      case RentalObjectCategory.Dwelling:
      case RentalObjectCategory.Parking:
      case RentalObjectCategory.Premises:
        segment = RentalObjectCategory[category].toLowerCase();
        break;

      case RentalObjectCategory.Other:
        segment = 'other-rental-object';
        break;

      default:
        throw new Error(`The specified contract category is not supported. Category: ${category}`);
    }
    return [segment, 'contracts', 'add'];
  }

  canExecute(command: Command): boolean {
    return command.id == rentalObjectFormCommand.createContract;
  }

  execute(command: Command): Observable<void> {
    return this._service.getByRentalObjectId(command.context.id).pipe(
      map(rentalObject => {
        this._navigation.navigate(this._path).then(result => {
          if (result) {
            this._messageDispather.send(rentalObject);
          }
        });
      })
    );
  }
}
